import { EventType, ToastSubType } from '../../../../constants'
import { ErrorLogFunction, EventTrackingFunction, ToastNotifyFunction } from '../../../../hooks'
import type { AnyEventData } from '../../../../types'
import { errorCodeToDisplayText } from '../../../../util/errorCodeToDisplayText'

interface Props {
  error: any
  eventData?: {
    data: AnyEventData
    type: EventType
  }
  fallbackErrorMessage?: string
  invalidateQueries?: () => void
  notify: ToastNotifyFunction
  toastSubType?: ToastSubType
  trackError: ErrorLogFunction
  trackEvent?: EventTrackingFunction
}

const handleSubmissionFailure = ({
  error,
  eventData,
  fallbackErrorMessage,
  invalidateQueries,
  notify,
  toastSubType,
  trackError,
  trackEvent,
}: Props) => {
  const statusCode = error?.toJSON().status
  const responseError = error?.response?.data ?? {}
  const { error_code: errorCode } = responseError
  const message = errorCodeToDisplayText(errorCode, statusCode, fallbackErrorMessage)

  trackError(error?.toJSON())

  notify(
    {
      message,
      type: toastSubType ?? ToastSubType.UNHANDLED_ERROR,
    },
    'error'
  )

  if (eventData && trackEvent) {
    const { data, type: eventType } = eventData

    trackEvent(eventType, { data })
  }

  if (invalidateQueries) {
    invalidateQueries()
  }
}

export { handleSubmissionFailure }
